import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { PlatformUpdateCard } from '../../shared/PlatformUpdateStatus';
import { usePermissions } from '../../shared/PermissionsContext';
import { formatDateTime } from '../../shared/tenantClock';

// Platform Dashboard: live cards only, each shown to Roles that can open
// the screen it summarises. No sample figures, since they'd read as the
// tenant's own data.

const CARD = { background: '#fff', border: '1px solid #b3bbc7', borderRadius: 10, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' };
const MUTED = { color: '#8a94a6', fontSize: 13 };
const EVENT_LABELS = {
  portal_sign_in: 'Portal sign-in',
  portal_sign_in_failed: 'Portal sign-in failed',
  document_edited: 'Document edited',
};
const DOCUMENT_TYPE_LABELS = { quote: 'Quote', sales_order: 'Sales Order' };
const RECENT_LIMIT = 5;

// The Audit Log's latest entries.
function RecentAuditCard() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get('/api/audit-log', { params: { limit: RECENT_LIMIT } })
      .then((res) => setRows(res.data.data || []))
      .catch(() => setRows([]));
  }, []);
  if (!rows) return null;
  return (
    <div style={CARD}>
      {rows.length === 0 ? (
        <div style={MUTED}>Nothing logged yet.</div>
      ) : (
        rows.map((row) => (
          <div key={row.id} style={{ display: 'flex', gap: 12, padding: '5px 0', fontSize: 14, borderBottom: '1px solid #eceef1' }}>
            <span style={{ ...MUTED, width: 140, flexShrink: 0 }}>{formatDateTime(row.occurred_at)}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              {EVENT_LABELS[row.event_type] || row.event_type}
              {row.document_number && <> · {DOCUMENT_TYPE_LABELS[row.document_type] || 'Document'} {row.document_number}</>}
              <span style={MUTED}> · {row.login_email || row.user_name || '—'}</span>
            </span>
          </div>
        ))
      )}
      <div style={{ ...MUTED, textAlign: 'right', marginTop: 8 }}>
        <Link to="/global-audit">Open Audit Log</Link>
      </div>
    </div>
  );
}

function GlobalDashboard() {
  const { accessFor } = usePermissions();
  const showUpdates = accessFor('global-platform-update-check').read;
  const showAudit = accessFor('global-audit').read;

  return (
    <div className="dashboard dashboard-page">
      <div className="dashboard-content">
        <div className="dashboard-content-inner">
          <div className="dashboard-page-header">
            <div className="dashboard-page-header-main">
              <h2 className="dashboard-page-title">Platform Dashboard</h2>
              <p className="dashboard-page-description">
                {showUpdates || showAudit ? 'Platform security updates and recent activity.' : 'Your Roles don’t include any of this dashboard’s cards.'}
              </p>
            </div>
          </div>

          {showUpdates && (
            <div className="metrics-section">
              <h2>Platform Update Check</h2>
              <PlatformUpdateCard />
            </div>
          )}

          {showAudit && (
            <div className="metrics-section">
              <h2>Recent Audit Log</h2>
              <RecentAuditCard />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default GlobalDashboard;
